import { showMessage } from "../store/message/actions";
import { store } from "../store/rootReducer";

export const showError = (message) => {
  store.dispatch(showMessage(message, "error"));
};
